import { createContext, useContext, useEffect, useState } from "react";
import { useSettings } from "../hooks/useSettings";

const LangContext = createContext(null);

export const translations = {
    ar: {
        nav_home: "الرئيسية",
        nav_order: "اطلب إطارك",
        nav_services: "خدماتنا",
        nav_company: "معلومات الشركة",
        nav_contact: "تواصل معنا",
        nav_whatsapp: "واتساب",
        nav_admin: "لوحة التحكم",
        nav_direct_call: "اتصال مباشر",
        hero_badge: "الوكيل والموزع المعتمد لأقوى الماركات العالمية في الرياض",
        hero_t1: "أمان قيادتك يبدأ من",
        hero_t2: "شركة إطار الثريا لخدمات السيارات",
        hero_t3: "دقة، ثبات، وأداء لا يُضاهى",
        hero_slogan: "«مع ميرو… إطارك أمانك»",
        hero_sub: "تجارة الجملة والتجزئة للإطارات العالمية — تشكيلة متكاملة لجميع فئات السيارات في حي الملز بالرياض، مع تركيب وترصيص فوري وضمان مصنعي معتمد.",
        hero_cta_order: "سجّل مقاسك وأرسل استفسارك",
        hero_cta_wa: "تحدث مع خبير الإطارات",
        hero_stats: ["+15 ماركة عالمية", "جملة وتجزئة", "تركيب وترصيص فوري", "ضمان رسمي معتمد"],
        hero_hud_line: "جملة وتجزئة — جميع الماركات العالمية",
        hero_hud_right: "ضمان رسمي معتمد",
        hero_float_t: "خدمة متنقلة",
        hero_float_s: "نجيك وين ما كنت",
        mob_badge: "الخدمة المتنقلة — البنشر المتنقل",
        mob_t1: "نجيك وين ما كنت",
        mob_t2: "في الدوام، في البيت، في الشارع",
        mob_desc: "ما عاد فيه داعي تقف طويل أو تترك شغلك — فريقنا المتنقل يوصل لموقعك بكامل المعدات: فك، تركيب، وترصيص إطاراتك الجديدة وأنت مرتاح.",
        mob_places: ["في الدوام", "في البيت", "في الشارع"],
        mob_cta: "اطلب الخدمة المتنقلة الآن",
        mob_img_cap: "بنشر شركة إطار الثريا لخدمات السيارات المتنقل",
        inq_eyebrow: "01 / ORDER NOW",
        inq_t1: "سجّل المقاس والنوعية…",
        inq_t2: "وخلّ الباقي علينا",
        inq_desc: "لا حاجة لتصفح قوائم طويلة — حدّد مقاس إطارك أو نوع سيارتك، ويصلك الرد بالسعر والتوفر مباشرة على واتساب.",
        inq_perks: [
            "رد سريع على استفسارك عبر واتساب",
            "أسعار الجملة والتجزئة تصلك حسب مقاسك مباشرة",
            "خدمة متنقلة للتركيب — نجيك وين ما كنت",
            "ضمان مصنعي معتمد وفاتورة ضريبية",
        ],
        inq_form_title: "نموذج الاستفسار السريع",
        inq_mode_size: "بمقاس الإطار",
        inq_mode_car: "بنوع السيارة",
        inq_sys_metric: "أوروبي (مم)",
        inq_sys_inch: "أمريكي (إنش)",
        inq_select_width: "عرض الإطار",
        inq_select_height: "الارتفاع (السلسلة)",
        inq_select_rim: "مقاس الجنط (R)",
        inq_select_dia: "القطر الكلي (إنش)",
        inq_select_width_in: "العرض (إنش)",
        inq_heavy_group: "إطارات ثقيلة (شاحنات)",
        inq_heavy_hint: "مقاس ثقيل — يُكتب بدون ارتفاع",
        inq_size_preview: "مقاسك:",
        inq_size_missing: "أكمل اختيار المقاس",
        inq_car_brand: "ماركة السيارة",
        inq_car_model: "الموديل",
        inq_car_trim: "الفئة (إن وجدت)",
        inq_car_rim: "مقاس الجنط الحالي (R)",
        inq_brand_ph: "ماركة الإطار المفضلة (اختياري)",
        inq_other: "ماركة أخرى",
        inq_type_ph: "نوعية الإطار — صيفي، شتوي... (اختياري)",
        inq_type_other: "نوعية أخرى",
        inq_qty_ph: "الكمية",
        inq_notes_ph: "ملاحظات إضافية — موعد التركيب، الخدمة المتنقلة... (اختياري)",
        inq_err_size: "فضلاً أكمل اختيار مقاس الإطار",
        inq_err_car: "فضلاً اختر ماركة السيارة والموديل ومقاس الجنط",
        inq_submit: "إرسال الاستفسار عبر واتساب",
        inq_disclaimer: "يتم فتح واتساب برسالة جاهزة تحتوي طلبك — بدون أي تسجيل أو التزام",
        srv_eyebrow: "02 / OUR MANIFESTO",
        srv_title: "خمسة التزامات نوقّع عليها مع كل إطار",
        srv_desc: "من التوريد بالجملة إلى التركيب النهائي — كل خطوة محسوبة لسلامتك على الطريق.",
        srv_cards: [
            { title: "تجارة وتوزيع الجملة للشركات والورش", desc: "عقود توريد دورية للشركات، معارض السيارات، ومراكز الصيانة في الرياض وكافة مناطق المملكة بأفضل أسعار الجملة." },
            { title: "مبيعات التجزئة للمستهلك النهائي", desc: "تشكيلة متكاملة لكافة فئات السيارات العائلية، الرياضية، وسيارات الدفع الرباعي مع استشارات مجانية لاختيار الإطار الأنسب." },
            { title: "خدمات التركيب والترصيص الدقيق", desc: "أحدث أجهزة الفك والتركيب بدون خدش الجنط، مع ترصيص دقيق لضمان ثبات تام على السرعات العالية." },
            { title: "ضمان الوكيل المعتمد والفاتورة الضريبية", desc: "جميع الإطارات جديدة بأحدث تواريخ الإنتاج ومشمولة بالضمان المصنعي الرسمي وفاتورة ضريبية نظامية." },
            { title: "خدمة متنقلة لتغيير الإطارات", desc: "نجيك وين ما كنت — في الدوام، في البيت، أو في الشارع. فك وتركيب وترصيص في موقعك بكامل المعدات دون عناء زيارة المحل." },
        ],
        loc_eyebrow: "03 / FIND US",
        loc_title: "مقرّنا في قلب الرياض — حي الملز",
        loc_cr: "السجل التجاري",
        loc_vat: "الرقم الضريبي",
        loc_postal: "الرمز البريدي",
        loc_addr_label: "العنوان",
        loc_addr_1: "الرياض — حي الملز — مجمع مواقف السيارات (كار بارك)",
        loc_addr_2: "شارع الأمير فهد بن إبراهيم آل سعود",
        loc_hours_1: "السبت — الخميس: 8:00 صباحاً — 10:00 مساءً",
        loc_hours_2: "الجمعة: 4:00 عصراً — 10:00 مساءً",
        loc_open_maps: "فتح في خرائط جوجل",
        gal_eyebrow: "04 / OUR SHOP",
        gal_title: "محلّنا على الطبيعة",
        gal_desc: "صور حقيقية من مقر شركة إطار الثريا لخدمات السيارات في مجمع مواقف السيارات (كار بارك) — حي الملز، الرياض.",
        gal_caps: ["واجهة المحل — نهاراً", "الواجهة المضيئة — ليلاً", "مدخل الخدمة والتركيب"],
        ftr_tagline: "شركة إطار الثريا لخدمات السيارات — تجارة الكفرات بالجملة والتجزئة. الثقة على كل طريق.",
        ftr_contact: "تواصل معنا",
        ftr_official: "بيانات رسمية",
        ftr_cr: "السجل التجاري:",
        ftr_vat: "الرقم الضريبي:",
        ftr_postal: "الرمز البريدي:",
        ftr_addr: "الرياض — حي الملز — مجمع مواقف السيارات — شارع الأمير فهد بن إبراهيم آل سعود",
        ftr_cta: "اطلب استشارتك الآن عبر واتساب",
        ftr_rights: "© 2026 شركة إطار الثريا لخدمات السيارات — جميع الحقوق محفوظة",
        ftr_follow: "تابعنا على",
        inq_car_year: "سنة الموديل",
        nav_blog: "المدونة",
        br_eyebrow: "02 / OUR BRANDS",
        br_title: "ماركات عالمية نفتخر بتمثيلها",
        br_desc: "من ميشلان إلى TESCHE — نوفر إطارات الوكيل الأصلية بضمان معتمد لكل مقاس واستخدام.",
        br_tesche_title: "TESCHE — إطارات الطرق الوعرة بروح مختلفة",
        br_tesche_desc: "نفخر بتقديم إطارات TESCHE في السعودية — أداء وحشي للبر والطين، بهوية الأصفر والأزرق ورمز اللانهاية.",
        br_tesche_cta: "اسأل عن إطارات TESCHE",
        blog_eyebrow: "05 / BLOG",
        blog_title: "مدونة شركة إطار الثريا لخدمات السيارات",
        blog_desc: "نصائح العناية بالإطارات وأدلة الاختيار وأخبار الماركات",
        blog_read: "اقرأ المقال",
        blog_all: "جميع المقالات",
        ftr_saso: "جميع إطاراتنا مطابقة للمعايير والمقاييس السعودية SASO",
        srv_c1_t: "تجارة وتوزيع الجملة للشركات والورش",
        srv_c1_d: "عقود توريد دورية للشركات، معارض السيارات، ومراكز الصيانة في الرياض وكافة مناطق المملكة بأفضل أسعار الجملة.",
        srv_c2_t: "مبيعات التجزئة للمستهلك النهائي",
        srv_c2_d: "تشكيلة متكاملة لكافة فئات السيارات العائلية، الرياضية، وسيارات الدفع الرباعي مع استشارات مجانية لاختيار الإطار الأنسب.",
        srv_c3_t: "خدمات التركيب والترصيص الدقيق",
        srv_c3_d: "أحدث أجهزة الفك والتركيب بدون خدش الجنط، مع ترصيص دقيق لضمان ثبات تام على السرعات العالية.",
        srv_c4_t: "ضمان الوكيل المعتمد والفاتورة الضريبية",
        srv_c4_d: "جميع الإطارات جديدة بأحدث تواريخ الإنتاج ومشمولة بالضمان المصنعي الرسمي وفاتورة ضريبية نظامية.",
        srv_c5_t: "خدمة متنقلة لتغيير الإطارات",
        srv_c5_d: "نجيك وين ما كنت — في الدوام، في البيت، أو في الشارع. فك وتركيب وترصيص في موقعك بكامل المعدات دون عناء زيارة المحل.",
        fl_wa: "تواصل واتساب",
        fl_call: "اتصال مباشر",
        fl_top: "العودة للأعلى",
    },
    en: {
        nav_home: "Home",
        nav_order: "Order Tires",
        nav_services: "Services",
        nav_company: "Company",
        nav_contact: "Contact",
        nav_whatsapp: "WhatsApp",
        nav_admin: "Admin",
        nav_direct_call: "Call Now",
        hero_badge: "Authorized dealer & distributor of top global tire brands in Riyadh",
        hero_t1: "Your driving safety starts with",
        hero_t2: "Al Thuraya Tire Auto Services Co",
        hero_t3: "Precision, stability, unmatched performance",
        hero_slogan: "“With Mero… your tire is your safety”",
        hero_sub: "Wholesale & retail of global tire brands — a complete range for every vehicle class in Al Malaz, Riyadh, with instant fitting, balancing and certified factory warranty.",
        hero_cta_order: "Enter your size & inquire",
        hero_cta_wa: "Talk to a tire expert",
        hero_stats: ["15+ global brands", "Wholesale & retail", "Instant fitting & balancing", "Certified warranty"],
        hero_hud_line: "Wholesale & retail — all global brands",
        hero_hud_right: "Certified official warranty",
        hero_float_t: "Mobile Service",
        hero_float_s: "We come to you",
        mob_badge: "Mobile Service — Mobile Tire Van",
        mob_t1: "We come to you, wherever you are",
        mob_t2: "At work, at home, on the road",
        mob_desc: "No more waiting or leaving your job — our mobile team arrives at your location with full equipment: removal, fitting and balancing of your new tires while you relax.",
        mob_places: ["At work", "At home", "On the road"],
        mob_cta: "Request mobile service now",
        mob_img_cap: "Al Thuraya Tire Auto Services Co mobile tire van",
        inq_eyebrow: "01 / ORDER NOW",
        inq_t1: "Enter size & brand…",
        inq_t2: "we handle the rest",
        inq_desc: "No long catalogs to browse — pick your tire size or your car, and get price & availability straight on WhatsApp.",
        inq_perks: [
            "Fast reply to your inquiry on WhatsApp",
            "Wholesale & retail prices sent for your exact size",
            "Mobile fitting service — we come to you",
            "Certified factory warranty & VAT invoice",
        ],
        inq_form_title: "Quick Inquiry Form",
        inq_mode_size: "By Tire Size",
        inq_mode_car: "By Car",
        inq_sys_metric: "Metric (mm)",
        inq_sys_inch: "US (inch)",
        inq_select_width: "Tire width",
        inq_select_height: "Aspect ratio",
        inq_select_rim: "Rim size (R)",
        inq_select_dia: "Overall diameter (in)",
        inq_select_width_in: "Width (in)",
        inq_heavy_group: "Heavy-duty (trucks)",
        inq_heavy_hint: "Heavy size — no aspect ratio",
        inq_size_preview: "Your size:",
        inq_size_missing: "Complete your size selection",
        inq_car_brand: "Car brand",
        inq_car_model: "Model",
        inq_car_trim: "Trim (if any)",
        inq_car_rim: "Your current rim size (R)",
        inq_brand_ph: "Preferred tire brand (optional)",
        inq_other: "Other brand",
        inq_type_ph: "Tire type — summer, winter... (optional)",
        inq_type_other: "Other type",
        inq_qty_ph: "Quantity",
        inq_notes_ph: "Extra notes — fitting time, mobile service... (optional)",
        inq_err_size: "Please complete your tire size selection",
        inq_err_car: "Please select car brand, model and rim size",
        inq_submit: "Send inquiry via WhatsApp",
        inq_disclaimer: "WhatsApp opens with a ready message containing your request — no signup, no commitment",
        srv_eyebrow: "02 / OUR MANIFESTO",
        srv_title: "Five commitments we sign with every tire",
        srv_desc: "From wholesale supply to final fitting — every step is measured for your safety on the road.",
        srv_cards: [
            { title: "Wholesale trade & distribution", desc: "Recurring supply contracts for companies, car showrooms and service centers across Riyadh and the Kingdom at the best wholesale prices." },
            { title: "Retail sales for end consumers", desc: "A complete range for family, sport and 4x4 vehicles with free consultations to pick the right tire." },
            { title: "Precision fitting & balancing", desc: "Latest scratch-free mounting machines and precise balancing for total stability at high speeds." },
            { title: "Certified warranty & VAT invoice", desc: "All tires are brand-new with the latest production dates, covered by official factory warranty and a legal VAT invoice." },
            { title: "Mobile tire-changing service", desc: "We come to you — at work, at home, or on the road. Removal, fitting and balancing at your location with full equipment." },
        ],
        loc_eyebrow: "03 / FIND US",
        loc_title: "Our home in the heart of Riyadh — Al Malaz",
        loc_cr: "Commercial Reg.",
        loc_vat: "VAT Number",
        loc_postal: "Postal Code",
        loc_addr_label: "Address",
        loc_addr_1: "Riyadh — Al Malaz — Car Park Complex",
        loc_addr_2: "Prince Fahd bin Ibrahim Al Saud Street",
        loc_hours_1: "Sat — Thu: 8:00 AM — 10:00 PM",
        loc_hours_2: "Friday: 4:00 PM — 10:00 PM",
        loc_open_maps: "Open in Google Maps",
        gal_eyebrow: "04 / OUR SHOP",
        gal_title: "Our shop, in real life",
        gal_desc: "Real photos from Al Thuraya Tire Auto Services Co headquarters at the Car Park Complex — Al Malaz, Riyadh.",
        gal_caps: ["Shopfront — daytime", "Lit storefront — night", "Service & fitting entrance"],
        ftr_tagline: "Al Thuraya Tire Auto Services Co — wholesale & retail tire trading. Trust on every road.",
        ftr_contact: "Contact Us",
        ftr_official: "Official Data",
        ftr_cr: "CR:",
        ftr_vat: "VAT:",
        ftr_postal: "Postal Code:",
        ftr_addr: "Riyadh — Al Malaz — Car Park Complex — Prince Fahd bin Ibrahim Al Saud St",
        ftr_cta: "Get your consultation on WhatsApp",
        ftr_rights: "© 2026 Al Thuraya Tire Auto Services Co — All rights reserved",
        ftr_follow: "Follow us",
        inq_car_year: "Model year",
        nav_blog: "Blog",
        br_eyebrow: "02 / OUR BRANDS",
        br_title: "Global brands we're proud to carry",
        br_desc: "From Michelin to TESCHE — genuine dealer tires with certified warranty for every size and use.",
        br_tesche_title: "TESCHE — off-road tires with a different spirit",
        br_tesche_desc: "Proudly offering TESCHE tires in Saudi Arabia — brutal off-road and mud performance, with the yellow & blue infinity identity.",
        br_tesche_cta: "Ask about TESCHE tires",
        blog_eyebrow: "05 / BLOG",
        blog_title: "Al Thuraya Tire Auto Services Co Blog",
        blog_desc: "Tire care tips, buying guides and brand news",
        blog_read: "Read article",
        blog_all: "All articles",
        ftr_saso: "All our tires comply with Saudi SASO standards",
        srv_c1_t: "Wholesale trade & distribution",
        srv_c1_d: "Recurring supply contracts for companies, car showrooms and service centers across Riyadh and the Kingdom at the best wholesale prices.",
        srv_c2_t: "Retail sales for end consumers",
        srv_c2_d: "A complete range for family, sport and 4x4 vehicles with free consultations to pick the right tire.",
        srv_c3_t: "Precision fitting & balancing",
        srv_c3_d: "Latest scratch-free mounting machines and precise balancing for total stability at high speeds.",
        srv_c4_t: "Certified warranty & VAT invoice",
        srv_c4_d: "All tires are brand-new with the latest production dates, covered by official factory warranty and a legal VAT invoice.",
        srv_c5_t: "Mobile tire-changing service",
        srv_c5_d: "We come to you — at work, at home, or on the road. Removal, fitting and balancing at your location with full equipment.",
        fl_wa: "WhatsApp chat",
        fl_call: "Call now",
        fl_top: "Back to top",
    },
};

export const LanguageProvider = ({ children }) => {
    const [lang, setLang] = useState(() => localStorage.getItem("thuraya_lang") || "ar");
    const settings = useSettings();

    useEffect(() => {
        document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
        document.documentElement.lang = lang;
        localStorage.setItem("thuraya_lang", lang);
    }, [lang]);

    const ov = (key) => {
        const k = lang === "ar" ? `txt_${key}` : `txt_${key}_en`;
        const v = settings[k];
        return typeof v === "string" && v.trim() ? v : null;
    };

    const t = (key) => ov(key) ?? translations[lang]?.[key] ?? translations.ar[key] ?? key;

    const FS_CLS = { sm: "fs-sm", md: "", lg: "fs-lg", xl: "fs-xl" };
    const fs = (key) => FS_CLS[settings[`fs_${key}`]] || "";

    const tr = new Proxy(translations[lang], {
        get: (obj, key) => {
            const v = ov(key);
            if (v && Array.isArray(obj[key])) return v.split("|").map((x) => x.trim()).filter(Boolean);
            return obj[key];
        },
    });

    return (
        <LangContext.Provider value={{ lang, setLang, t, tr, fs }}>
            {children}
        </LangContext.Provider>
    );
};

export const useLang = () => useContext(LangContext);
